import React from 'react'
import styled from 'styled-components'
import { useComments } from 'querys/comments'

const NoCommentStyled = styled.div`
  font: var(--regularBold);
  text-align: center;
  color: var(--neutralText);
  margin-bottom: 68px;
  img {
    width: 100%;
  }
  .img-container {
    position: relative;
  }
  .no-comments {
    position: absolute;
    top: 77%;
    bottom: 0;
    padding: 8px 0;
    background: rgba(4, 0, 30, 0.8);
    right: 0;
    left: 0;
    &::before {
      content: '';
      position: absolute;
      background: linear-gradient(90deg, #04001E 4.23%, #FF7BFF 48.62%, #04001E 100%);
      height: 2px;
      left: 0;
      top: 0;
      right: 0;
    }
  }
  .light {
    display: none;
  }
  .dark {
    display: block;
  }
  @media(min-width: 768px) {
    font: var(--headline6);
    .no-comments {
      padding: 16px 0;
    }
  }
`

function NoComment() {
  const { data } = useComments()
  const { count } = data || {}

  if (!count || count === 0) {
    return (
      <NoCommentStyled>
        <div className="img-container">
          <img className="light" src="/images/comments/no-comments-ilustration-light.png" alt="Ilustraccin de ausencia de comentarios" loading="lazy" />
          <img className="dark" src="/images/comments/no-comments-ilustration.png" alt="Ilustraccin de ausencia de comentarios" loading="lazy" />
          <div className="no-comments">
            <p>¿Te gustó la clase?</p>
            <p>Sé el primero en comentar, regalar un tip o preguntar de esta clase</p>
          </div>
        </div>
      </NoCommentStyled>
    )
  }

  if (count <= 5) {
    return (
      <NoCommentStyled>
        <div className="img-container">
          <img className="light" src="/images/comments/no-comments-ilustration-light.png" alt="Ilustraccin de ausencia de comentarios" loading="lazy" />
          <img className="dark" src="/images/comments/no-comments-ilustration.png" alt="Ilustraccin de ausencia de comentarios" loading="lazy" />
          <div className="no-comments">
            <p>¿Tienes alguna pregunta?</p>
            <p>Estamos muy pendiente de que tengas la mejor experiencia de aprendizaje</p>
          </div>
        </div>
      </NoCommentStyled>
    )
  }

  return null
}

export default NoComment
